require('../../styles/blocks/_clone-elements.scss');
const React = require('react');
const PropTypes = require('prop-types');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
import { formatText, FormattedText } from 'core/i18n';

const { InputText } = require('components/inputText/inputText');
const SelectList = require('components/selectList/selectList').SelectList;
const validator = require('validator');
const scroll = require('utilities/scroll');
const { getReferenceCodeByCountry } = require('utilities/multiLanguageHelper');
import { sort } from 'utilities/ArrayUtils/ArrayUtils';

const actions = require('actions/initialActions');

class TaxationElements extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            country: '',
            tin: '',
            validTin: true,
        };
        this.handleAddBox = this.handleAddBox.bind(this);
        this.handleRemoveBox = this.handleRemoveBox.bind(this);
        this.buildRemove = this.buildRemove.bind(this);
        this.buildBox = this.buildBox.bind(this);
        this.getCountries = this.getCountries.bind(this);
        this.findInArray = this.findInArray.bind(this);
        this.generateChildren = this.generateChildren.bind(this);
        this.handleOnRef = this.handleOnRef.bind(this);
        this.updatedTaxationReason = this.updatedTaxationReason.bind(this);
        this.updatedTaxationCountry = this.updatedTaxationCountry.bind(this);
        this.updatedTaxationTin = this.updatedTaxationTin.bind(this);

        this.blockElements = [];
    }

    UNSAFE_componentWillMount() {
        const { userProfile, formActions } = this.props;

        if (typeof userProfile.taxationCounter === 'undefined') {
            formActions.push('userProfile.taxationCounter', 1);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userProfile.taxationCounter !== this.props.userProfile.taxationCounter) {
            const lastElement = this.blockElements[this.blockElements.length - 1];
            if (lastElement) {
                scroll.transition(lastElement);
            }
        }
    }

    findInArray(arr, obj) {
        return arr.indexOf(obj.value) !== -1;
    }

    getCountries(current, list) {
        const { userProfile } = this.props;
        const currentCountry = userProfile[`taxation_country_${userProfile.taxationCounter[current]}`];
        const countries = [];
        let country = {};
        const disabledCountries = [];
        list.map(value => {
            if (userProfile[`taxation_country_${value}`] !== currentCountry) {
                disabledCountries.push(userProfile[`taxation_country_${value}`]);
            }
        });
        this.props.options.get('countries').map(value => {
            country = value.toObject();
            if (
                country.value !== getReferenceCodeByCountry().toUpperCase() &&
                !this.findInArray(disabledCountries, country)
            ) {
                countries.push(country);
            }
        });

        return sort(countries, 'label');
    }

    buildRemove(i) {
        const { userProfile, disabled } = this.props;
        const handleRemoveBox = this.handleRemoveBox;
        if (!!disabled || Object.keys(userProfile.taxationCounter).length > 1) {
            return (
                <a
                    href="#"
                    onClick={function (event) {
                        event.preventDefault();
                        handleRemoveBox(userProfile.taxationCounter[i]);
                    }}
                >
                    <i className="icons icons--icon-delete-3"></i>
                </a>
            );
        }
    }

    updatedTaxationReason(index, value) {
        const { handleSave, taxation } = this.props;
        const content = [];
        let reasonResident, reasonCitizen;

        switch (value) {
            case 'RE':
                reasonResident = true;
                reasonCitizen = false;
                break;
            case 'CI':
                reasonResident = false;
                reasonCitizen = true;
                break;
            case 'AM':
                reasonResident = true;
                reasonCitizen = true;
                break;
            default:
                reasonResident = false;
                reasonCitizen = false;
                break;
        }
        content.push({
            taxationIndex: index,
            citizenship: reasonCitizen,
            residency: reasonResident,
        });

        taxation.taxationDetails = content;
        handleSave('taxation', taxation);
    }

    updatedTaxationCountry(index, value) {
        const { handleSave, taxation, userProfile } = this.props;
        const content = [];

        if (!value) {
            return;
        }

        content.push({
            taxationIndex: index,
            country: value,
        });

        taxation.taxationDetails = content;
        handleSave('taxation', taxation);

        this.setState(
            {
                country: value,
            },
            () => {
                this.validateTin(userProfile[`taxation_tin_code_${userProfile.taxationCounter[index]}`], index);
            }
        );
    }

    updatedTaxationTin(index) {
        const { userProfile, handleSave, taxation } = this.props;
        const content = [];
        content.push({
            taxationIndex: index,
            tin: userProfile[`taxation_tin_code_${userProfile.taxationCounter[index]}`],
        });

        taxation.taxationDetails = content;
        handleSave('taxation', taxation);
        this.setState({ tin: userProfile[`taxation_tin_code_${userProfile.taxationCounter[index]}`] });
    }

    handleOnRef(element) {
        this.blockElements.push(element);
    }

    validateTin = (value, index) => {
        const { actions, formActions, userProfile } = this.props;
        const taxationIndex = userProfile.taxationCounter[index];
        const countryModel = `taxation_country_${taxationIndex}`;
        const country = userProfile[countryModel];
        const tinProfileModel = `userProfile.taxation_tin_code_${taxationIndex}`;
        const countryProfileModel = `userProfile.${countryModel}`;
        if (!value) {
            return value;
        }

        formActions.change(`userProfile.validatingTin_${taxationIndex}`, true);
        formActions.change('userProfile.validatingTin', true);
        formActions.resetValidity(countryProfileModel);
        formActions.resetValidity(tinProfileModel);

        actions.tinVerify(country, value, ({ isValid, isInvalidCountry, isInvalidTin }) => {
            setTimeout(() => {
                isInvalidCountry && formActions.setValidity(countryProfileModel, { valid: false });
                isInvalidTin && formActions.setValidity(tinProfileModel, { valid: false });
                isValid && formActions.setValidity(tinProfileModel, { valid: isValid });

                formActions.change('userProfile.validatingTin', false);
                formActions.change(`userProfile.validatingTin_${taxationIndex}`, false);
            }, 500);
        });

        return value;
    };

    generateChildren(index) {
        const { userProfile, userProfileForm, formActions, disabled } = this.props;
        const updatedTaxationCountry = this.updatedTaxationCountry;
        const updatedTaxationReason = this.updatedTaxationReason;
        const updatedTaxationTin = this.updatedTaxationTin;

        return (
            <div ref={this.handleOnRef}>
                <div className="row">
                    <div className="col-md-4 col-lg-4 content-element-cloned__group-element">
                        <SelectList
                            profileModel={`userProfile.taxation_country_${userProfile.taxationCounter[index]}`}
                            optionsList={this.getCountries(index, userProfile.taxationCounter)}
                            clearable={false}
                            searchable={true}
                            label={<FormattedText value="field-taxationCountry" />}
                            placeholder={formatText('field-selectAnCountry')}
                            messagesError={{
                                required: formatText('validation-selectRequired'),
                                valid: formatText('validation-selectRequired'),
                            }}
                            validations={{
                                required: value => value,
                            }}
                            required
                            onChange={function (value) {
                                updatedTaxationCountry(index, value);
                            }}
                            userProfile={userProfile}
                            userProfileForm={userProfileForm}
                            formActions={formActions}
                            focusAnimated
                            disabled={disabled}
                        />
                    </div>
                    <div className="col-md-4 col-lg-4 content-element-cloned__group-element">
                        <InputText
                            profileModel={`userProfile.taxation_tin_code_${userProfile.taxationCounter[index]}`}
                            label={formatText('field-tinCode')}
                            validations={{
                                required: value => value && value.length,
                                valid: value =>
                                    validator.matches(value, /^[a-z0-9\d\w\sáéíóú\xF1 \xD1 ._-]*$/) &&
                                    value.length <= 20,
                            }}
                            isValidated={function () {
                                updatedTaxationTin(index);
                            }}
                            onBlur={value => this.validateTin(value, index)}
                            messagesError={{
                                required: formatText('validation-tinCodeRequired'),
                                valid: formatText('validation-tinCodeValidation'),
                            }}
                            required
                            disabled={disabled || userProfile[`validatingTin_${userProfile.taxationCounter[index]}`]}
                            userProfile={userProfile}
                            userProfileForm={userProfileForm}
                            formActions={formActions}
                            autoCompleteField={false}
                            focusAnimated
                            isLoading={userProfile[`validatingTin_${userProfile.taxationCounter[index]}`]}
                        />
                    </div>
                    <div className="col-md-4 col-lg-4 content-element-cloned__group-element">
                        <SelectList
                            classNameLabel="reasonSelect"
                            profileModel={`userProfile.taxation_reason_${userProfile.taxationCounter[index]}`}
                            optionsList={[
                                {
                                    label: formatText('field-citizenship'),
                                    value: 'CI',
                                },
                                {
                                    label: formatText('field-residence'),
                                    value: 'RE',
                                },
                                {
                                    label: formatText('field-both'),
                                    value: 'AM',
                                },
                            ]}
                            clearable={false}
                            searchable={true}
                            label={<FormattedText value="field-reason" />}
                            placeholder={formatText('field-select')}
                            validations={{
                                required: value => value,
                            }}
                            onChange={function (value) {
                                updatedTaxationReason(index, value);
                            }}
                            messagesError={{ required: formatText('validation-selectRequired') }}
                            userProfile={userProfile}
                            userProfileForm={userProfileForm}
                            formActions={formActions}
                            required
                            focusAnimated
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildBox(cant) {
        const { disabled, title, removable } = this.props;
        const length = cant ? Object.keys(cant).length : 0;
        const boxes = [];
        const generateChildren = this.generateChildren;

        for (let i = 0; i < length; i++) {
            const newChildren = generateChildren(i);

            boxes[cant[i]] = (
                <div key={`element_${i}`} className="content-element-cloned">
                    <div className="content-element-cloned__header">
                        {title ? <h6 className="font-heading6">{`${title} ${i + 1}`}</h6> : ''}
                        {removable && !disabled ? <span>{this.buildRemove(i)}</span> : ''}
                    </div>
                    {newChildren}
                </div>
            );
        }

        return boxes;
    }

    handleAddBox() {
        const { userProfile, formActions, limit } = this.props;
        const num = Object.keys(userProfile.taxationCounter).length;
        if (limit && num < limit) {
            formActions.push('userProfile.taxationCounter', parseInt(userProfile.taxationCounter[num - 1]) + 1);
        }
    }

    handleRemoveBox(id) {
        const { userProfile, formActions, handleSave, taxation } = this.props;
        const index = userProfile['taxationCounter'].indexOf(id);
        formActions.remove('userProfile.taxationCounter', index);
        let reasonResident = false,
            reasonCitizen = false;
        const content = userProfile.taxationCounter
            .map((value, i) => {
                if (i !== index) {
                    switch (userProfile[`taxation_reason_${value}`]) {
                        case 'RE':
                            reasonResident = true;
                            reasonCitizen = false;
                            break;
                        case 'CI':
                            reasonResident = false;
                            reasonCitizen = true;
                            break;
                        case 'AM':
                            reasonResident = true;
                            reasonCitizen = true;
                            break;
                        default:
                            reasonResident = false;
                            reasonCitizen = false;
                            break;
                    }

                    return {
                        taxationIndex: i,
                        country: userProfile[`taxation_country_${value}`],
                        citizenship: reasonCitizen,
                        residency: reasonResident,
                        tin: userProfile[`taxation_tin_code_${value}`],
                    };
                }
            })
            .filter(taxationCountries => taxationCountries != undefined && taxationCountries.country);

        formActions.change(`userProfile.taxation_country_${id}`, '');
        formActions.change(`userProfile.taxation_tin_code_${id}`, '');
        formActions.change(`userProfile.taxation_reason_${id}`, '');
        formActions.setErrors(`userProfile.taxation_country_${id}`, false);
        formActions.setErrors(`userProfile.taxation_tin_code_${id}`, false);
        formActions.setErrors(`userProfile.taxation_reason_${id}`, false);
        taxation.taxationDetails = content;
        taxation.delete = 'true';
        handleSave('taxation', taxation);
    }

    render() {
        const { userProfile, limit, disabled } = this.props;
        const showButtonAddClass =
            (userProfile.taxationCounter && Object.keys(userProfile.taxationCounter).length >= limit) || disabled
                ? 'hidden'
                : '';

        return (
            <div>
                {this.buildBox(userProfile.taxationCounter)}
                <div className={`content-element-cloned__add-element ${showButtonAddClass}`}>
                    <button
                        disabled={showButtonAddClass}
                        type="button"
                        className="form__button form__button-primary add-button"
                        onClick={this.handleAddBox}
                    >
                        <i className="icons icons--icon-add-blue" />
                        <FormattedText value="button-addCountry" />
                    </button>
                </div>
            </div>
        );
    }
}

TaxationElements.propTypes = {
    limit: PropTypes.number,
    remove: PropTypes.bool,
    title: PropTypes.string,
    removable: PropTypes.bool,
};

TaxationElements.defaultProps = {
    limit: 4,
    remove: false,
    title: false,
    removable: true,
};

module.exports.constructor = TaxationElements;
module.exports.TaxationElements = connect(
    state => ({
        options: state.options,
    }),
    dispatch => ({
        actions: bindActionCreators(actions, dispatch),
    })
)(TaxationElements);
